import type { App } from "vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "core-js/stable";
import "mutationobserver-shim";
import "regenerator-runtime/runtime";
import { createBootstrap } from "bootstrap-vue-next";
import VueKonva from "vue-konva";
import router from "@/router";
import pinia from "@/store";
import { createAppGlobalsPlugin } from "@/composables/useAppGlobals";
import api from "@/utils/api";
import Cookie from "@/utils/cookie";
import Constants from "@/utils/constants";
import i18n from "@/i18n";

export function registerAppPlugins(app: App) {
  app.use(pinia);
  app.use(router);
  app.use(createAppGlobalsPlugin(api, Cookie, Constants, router));
  app.use(createBootstrap());
  app.use(VueKonva);
  app.use(i18n);
}
